import React, { Fragment, useState, useEffect } from "react";
import ProductItem from "./ProductItem";
import APIService from "../services/APIService";
export default function ProductsWithin() {
  const [activeCategory, setActiveCategory] = useState(0);
  const [categorys, setCategory] = useState([]);
  const [products, setProducts] = useState([]);

  async function suggestCate() {
    const RESULT = await APIService.suggestCate();
    if (RESULT) {
      setCategory([{ name: "Tất cả", id: 0 }, ...RESULT]);
    }
  }

  async function suggestProduct(idCate) {
    const RESULT = await APIService.suggestProduct(idCate);
    if (RESULT) {
      setProducts(RESULT.data);
    }
  }

  useEffect(() => {
    suggestCate();
  }, []);

  useEffect(() => {
    suggestProduct(activeCategory);
  }, [activeCategory]);
  return (
    <Fragment>
      <div className="flex flex-1 sm:flex justify-between items-center mb-[23px] border-b-2 border-[#EBEBEB]">
        <h3 className="sm:text-[26px] text-[#222222] flex flex-1 text-lg font-bold mr-6 sm:max-w-[200px] min-w-[200px]">
          Gợi ý hôm nay
        </h3>
        <ul className="category-filter sm:max-w-[200px] sm:flex flex flex-2 ml-4 uppercase text-[16px]">
          <li
            className={`truncate max-w-[200px] sm:text-[16px] text-[#222222] text-[10px] mr-4 cursor-pointer py-4 ${
              categorys[0]?.id === activeCategory ? "active" : ""
            }`}
            onClick={() => setActiveCategory(categorys[0]?.id)}
          >
            {categorys[0]?.name}
          </li>
        </ul>
        <div className="overflow-x-scroll sroll-within">
          <ul className="category-filter sm:flex flex flex-2 ml-4 uppercase text-[16px]">
            {categorys.slice(1).map((item, index) => (
              <li
                key={index}
                className={`truncate sm:max-w-[200px] text-[#222222] min-w-[200px] sm:text-[16px] text-[10px] mr-4 cursor-pointer py-4 ${
                  item.id === activeCategory ? "active" : ""
                }`}
                onClick={() => setActiveCategory(item.id)}
              >
                {item.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="grid sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 grid-cols-2 sm:gap-[26px] gap-2">
        {products.map((item, index) => (
          <ProductItem product={item} key={index} />
        ))}
      </div>
    </Fragment>
  );
}
